import React from "react";
import { useTranslation } from "react-i18next";
import { Split } from "./UsersOverview";

/** iOS vs Android share of downloads and active devices. */
const PlatformShare = ({ ios, android, loading }) => {
  const { t } = useTranslation();
  const rows = [
    { title: t("Total downloads"), key: "downloads" },
    { title: t("Downloads, last 30 days"), key: "downloadsLast30Days" },
    { title: t("Active devices, last 30 days"), key: "activeDevices" },
  ].filter(({ key }) => ios?.[key] != null && android?.[key] != null);

  return (
    <section className="dash-card">
      <div className="dash-card-header">
        <h2 className="dash-card-title">{t("Platform share")}</h2>
      </div>
      {loading ? (
        <div className="dash-skeleton" style={{ height: 170 }} />
      ) : rows.length === 0 ? (
        <p className="dash-empty">{t("Not enough data to compare platforms")}</p>
      ) : (
        rows.map(({ title, key }) => (
          <Split
            key={key}
            title={title}
            parts={[
              { label: "iOS", value: ios[key], color: "var(--dash-blue)" },
              { label: "Android", value: android[key], color: "var(--dash-green)" },
            ]}
          />
        ))
      )}
    </section>
  );
};

export default PlatformShare;
